import { render, staticRenderFns } from "./AddNewTriesModal.vue?vue&type=template&id=510242aa"
import script from "./AddNewTriesModal.vue?vue&type=script&lang=js"
export * from "./AddNewTriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports